import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const KINDS = [["qr_scan", "QR"], ["ad_click", "Ad"], ["call_click", "Calls"], ["website_click", "Web"], ["facebook_click", "FB"],
  ["instagram_click", "IG"], ["contact_form", "Msgs"], ["ai_chat", "AI"]];

function Table({ head, rows, testid }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-border" data-testid={testid}>
      <table className="w-full text-xs">
        <thead className="bg-slate-50 text-sam-slate"><tr>{head.map((h) => <th key={h} className="px-2 py-2 text-left font-semibold">{h}</th>)}</tr></thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}

export default function LeadsBoard() {
  const [days, setDays] = useState(30);
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/admin/lead-events/summary?days=${days}`).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [days]);
  const reps = useMemo(() => {
    const m = {};
    (rows || []).forEach((r) => {
      const k = r.rep || "Unassigned";
      const e = m[k] || (m[k] = { rep: k, total: 0, businesses: 0 });
      e.total += r.total; e.businesses += 1;
    });
    return Object.values(m).sort((a, b) => b.total - a.total);
  }, [rows]);
  if (!rows) return null;
  return (
    <div className="space-y-4 mb-6" data-testid="leads-board">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h3 className="font-display font-bold text-sam-navy">Leads board</h3>
        <div className="flex gap-1" data-testid="leads-board-range">
          {[7, 30, 90].map((d) => (
            <button key={d} onClick={() => setDays(d)} className={`rounded-full px-3 py-1 text-xs font-semibold ${days === d ? "bg-sam-navy text-white" : "bg-slate-100 text-sam-navy"}`} data-testid={`leads-board-days-${d}`}>{d} days</button>
          ))}
        </div>
      </div>
      {rows.length === 0 ? <p className="text-sm text-sam-slate" data-testid="leads-board-empty">No leads tracked in this period yet.</p> : (
        <>
          <Table testid="leads-board-reps" head={["Rep", "Businesses", "Leads"]} rows={reps.map((r) => (
            <tr key={r.rep} className="border-t border-border"><td className="px-2 py-1.5 font-mono font-semibold text-sam-navy">{r.rep}</td><td className="px-2">{r.businesses}</td><td className="px-2 font-bold">{r.total}</td></tr>
          ))} />
          <Table testid="leads-board-businesses" head={["Business", "Rep", ...KINDS.map((k) => k[1]), "Total"]} rows={rows.map((r) => (
            <tr key={`${r.business_id}-${r.rep}`} className="border-t border-border" data-testid={`leads-board-row-${r.business_id}`}>
              <td className="px-2 py-1.5 font-semibold text-sam-navy">{r.name || r.business_id}</td>
              <td className="px-2 font-mono">{r.rep || "—"}</td>
              {KINDS.map(([k]) => <td key={k} className="px-2">{r.kinds[k] || 0}</td>)}
              <td className="px-2 font-bold">{r.total}</td>
            </tr>
          ))} />
        </>
      )}
    </div>
  );
}
